import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ReportCellEditorPage } from 'src/app/pages/report-cell-editor/report-cell-editor.page';

@Component({
  selector: 'app-editable-row',
  templateUrl: './editable-row.component.html',
  styleUrls: ['./editable-row.component.scss'],
})
export class EditableRowComponent implements OnInit {

  @Input( ) item:any;

  @Input() index:number;
  @Input() order:any;
  headers:string[] = [];
  private _modal: any;
  @Output() itemChanged:EventEmitter<any> = new EventEmitter<any>();
  constructor(public modalController: ModalController) { }

  ngOnInit() {}
  async openForm(item,prop){
      if(!item[prop].error) return;
      this._modal = await this.modalController.create({
        component: ReportCellEditorPage,
        cssClass:'report-cell-editor',
        backdropDismiss:false,
        keyboardClose:false,
        swipeToClose:false,
        componentProps: {
          item: item,
          prop: prop
        }
      });
      await this._modal.present()
      console.log({openForm:{item,prop}})
      const { data } = await this._modal.onWillDismiss();
      if(data){
          this.submit( data );
      }


  }
  submit(data){
    console.log('sbumit',data)
    let item = this.item;
    Object.keys(data).forEach( (k)=>{
      item[k]=data[k];
    })
    this.item = item;
    this.itemChanged.emit( this.item );
  }
}
